import { PositionsPanel } from "../components/PositionsPanel";
import { usePositionsPoll } from "../hooks/usePositionsPoll";

export function PositionsPage() {
  const { positions, bridgeConnected } = usePositionsPoll();
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold tracking-tight">Open positions</h1>
      <PositionsPanel positions={positions} bridgeConnected={bridgeConnected} />
    </div>
  );
}
